import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import Loader from "../components/Loader";
import InnerBannerBreadcrumb from "../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../redux/services/apiSlice";
import PageLastUpdated from "../components/shared/PageLastUpdated";
import { extractDateFromStr, getLatestUpdatedObject } from "../Utils/utils";

const ChallengesDetailPage = () => {
  const { id } = useParams();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: challengesData = [], isLoading: challengesIsLoading } =
    useGetProtectedApiDataQuery({ url: "challenges", lang: languageType });

  const challengesObj = challengesData.find((item) => item.nid === id);

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(getLatestUpdatedObject(challengesData)?.changed);
  }, [challengesData]);

  if (challengesIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="images/inner_aboutbann.jpg"
        title={challengesObj?.title}
        titleLink="/publication-detail"
        levelTwo={false}
        levelThree={false}
        isActive={challengesObj?.title}
      />
      <div className="inner-container">
        <div className="container">
          <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
          <section className="ourCompany">
            <div className="container">
              <div className="row mb-5">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mvDescWrap">
                  <div className="about_inntxt">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: challengesObj?.body_1,
                      }}
                    ></p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ChallengesDetailPage;
